// extracted by mini-css-extract-plugin
export default {"withoutprint":"transcript_withoutprint__qJZ-M"};